export default {
  welcome: 'Velkommen tilbage',
  accounts: 'Konti',
  account: 'Konto',
  dashboard: "Kontrolpanel",
  loading: 'Indlæser...',
  products: "Produkter",
  suppliers: "Leverandører",
  customers: "Kunder",
  users: "Brugere",
  product: "Produkt",
  productStatus: "Vare status",
  newProduct: "Nyt produkt",
  errorCreateProduct: "Der opstod en fejl ved oprettelse af varen, kontroller venligst alle felter igen.",
  errorUpdateProduct: "Der opstod en fejl ved opdatering af varen, kontroller venligst alle felter igen.",
  errorDeleteProduct: "Der opstod en fejl ved sletning af varen.",
  regulationsSuccess: "Regulering gennemført",
  regulationsError: "Regulering fejl, kontroller venligst alle felter igen.",
  restock: "Genbestil",
  editProduct: "Rediger vare",
  deleteProduct: "Slet produkt",
  productCreated: "ProduktVare oprettet",
  productUpdated: "Produkt opdateret",
  productDeleted: "Produkt slettet",
  regulateQuantity: "Reguler antal",
  addSubtract: "Tilføj / Fjern fra",
  editLocation: "Rediger lokation",
  deleteLocation: "Slet lokation",
  missingLocation: "Manglende lokation",
  newLocation: "Ny lokation",
  movementFrom: "Flytning fra",
  cancel: "Annuller",
  move: "Flyt",
  currentStock: "Aktuelt lager",
  stockRegulations: "Lagerreguleringer",
  quantityToMove: "Antal at flytte",
  locationCreated: "Lokation oprettet",
  locationUpdated: "Lokation opdateret",
  locationDeleted: "Lokation slettet",
  editSupplier: "Rediger leverandør",
  deleteSupplier: "Slet leverandør",
  newSupplier: "Ny leverandør",
  supplierCreated: "Leverandør oprettet",
  supplierUpdated: "Leverandør opdateret",
  supplierDeleted: "Leverandør slettet",
  newCustomer: "Ny kunde",
  editCustomer: "Rediger kunde",
  deleteCustomer: "Slet kunde",
  customerCreated: "Kunde oprettet",
  customerUpdated: "Kunde opdateret",
  customerDeleted: "Kunde slettet",
  companyNumber: "CVR-nummer",
  companyName: "Firmanavn",
  address1: "Adresse 1",
  address2: "Adresse 2",
  city: "By",
  zipCode: "Postnummer",
  country: "Land",
  contactPhone: "Kontakt telefon",
  contactEmail: "Kontakt email",
  contactPerson: "Kontakt person",
  supplier: "Leverandør",
  customer: "Kunde",
  purchases: "indkøb",
  purchase: "indkøb",
  sales: "Salg",
  sale: "Salg",
  user: "Bruger",
  about: "Om Capture IT",
  orders: "Ordre",
  inventory: "Lager",
  reports: "Rapporter",
  priceValue: "Lager værdi",
  stockValue: "Lager værdi",
  regulations: "Lagerreguleringer",
  stockMovements: "Lagerflytninger",
  checkingDrafts: "Lager optælling",
  locations: "Lokationer",
  location: 'Lokation',
  locationNumber: 'Lokationsnummer',
  defaultLocation: 'Standard lokation',
  mandatoryDefaultLocation: '*Standard lokation',
  number: 'Nummer',
  name: 'Navn',
  locationName: 'Lokationsnavn',
  selectRemoveAll: 'Tilføj / fjern alle',
  accountNumber: 'Kontonummer',
  fullname: 'Fulde navn',
  email: 'E-mail',
  role: 'Rolle',
  actions: 'Handlinger',
  general: 'Generelt',
  other: 'Andet',
  update: 'Opdater',
  image: 'Billede',
  productImage: 'Produktbillede',
  barcode: 'Stregkode',
  quantity: 'Antal',
  labelQuantity: 'Antal labels',
  price: 'Pris',
  pricePerUnit: 'Pris pr. enhed',
  salesPrice: 'Salgspris',
  purchasePrice: 'Kostpris',
  total: 'Total',
  productName: 'Varenavn',
  mandatoryProductName: '*Varenavn',
  productNumber: 'Varenummer',
  mandatoryProductNumber: '*Varenummer',
  productGroup: 'Varegruppe',
  stock: 'Lager',
  minStock: 'Minimum lager',
  status: 'Status',
  published: 'Åben',
  scheduled: 'Planlagt',
  inactive: 'Lukket',
  date: 'Dato',
  description: 'Beskrivelse',
  height: 'Højde',
  width: 'Bredde',
  depth: 'Dybde',
  weight: 'Vægt',
  usersPerPageText: 'Brugere pr. side:',
  productsPerPageText: 'Produkter pr. side:',
  locationsPerPageText: 'Lokationer pr. side:',
  suppliersPerPageText: 'Leverandører pr. side:',
  customersPerPageText: 'Kunder pr. side:',
  purchasesPerPageText: 'Køb pr. side:',
  salesPerPageText: 'Salg pr. side:',
  ordersPerPageText: 'Ordre pr. side:',
  itemsPerPageText: 'Linjer pr. side:',
  of: 'af',
  to: 'til',
  on: 'på',
  one: 'en',
  note: 'Bemærkning',
  pageText: '{0}-{1} af {2}',
  fullnameMandatory: 'Fulde navn er påkrævet',
  emailInvalid: 'Ugyldig e-mail',
  userMandatory: 'Brugernavn og adgangskode er påkrævet',
  emailMandatory: 'E-mail er påkrævet',
  userCreated: 'Bruger oprettet!',
  errorCreateUser: 'Der opstod en fejl ved oprettelse af bruger, check alle felter igen.',
  userdeleted: 'Brugeren er blevet slettet',
  errorDeleteUser: 'Fejl ved sletning af bruger',
  appname: 'PicklyWMS',
  login: 'Log ind',
  settings: 'Indstillinger',
  importExport: 'Import / Eksport',
  import: 'Importér',
  export: 'Eksportér',
  importProducts: 'Importér produkter',
  exportProducts: 'Eksportér produkter',
  uploadFile: 'Upload fil',
  uploadFileText: 'Træk en Excel eller CSV-fil hertil.',
  uploadSucceded: 'Uploadet med succes',
  uploadFailed: 'Upload fejlede',
  language: 'Sprog',
  darkMode: 'Mørk tilstand',
  showProducts: 'Vis inaktive produkter',
  showLocations: 'Vis inaktive lokationer',
  selectLanguage: 'Vælg sprog',
  danish: 'Dansk',
  english: 'Engelsk',
  swedish: 'Svensk',
  norwegian: 'Norsk',
  finnish: 'Finsk',
  enabled: 'Aktiveret',
  disabled: 'Deaktiveret',
  required: 'Påkrævet',
  optional: 'Valgfri',
  username: 'Brugernavn',
  password: 'Adgangskode',
  print: 'Udskriv',
  printSelected: 'Udskriv valgte',
  close: 'Luk',
  save: 'Gem',
  reset: 'Nulstil',
  clear: 'Ryd',
  create: 'Opret',
  edit: 'Rediger',
  delete: 'Slet',
  confirmDelete: 'Bekræft sletning',
  deleteWarningProduct: 'Er du sikker på, at du vil slette produktet?',
  deleteWarningUser: 'Er du sikker på, at du vil slette denne bruger?',
  error: 'Fejl',
  success: 'Succes',
  info: 'Info',
  warning: 'Advarsel',
  submit: 'Send',
  search: 'Søg',
  newUser: 'Ny bruger',
  editUser: 'Rediger bruger',
  deleteUser: 'Slet bruger',
  userDeleted: 'Bruger slettet!',
  userUpdated: 'Bruger opdateret!',
  oneRegistered: 'Der er registreret en',
  thereAreXRegistered: 'Der er registreret',
  weHaveOneRegistered: 'Vi har registreret en',
  weHaveXRegistered: 'Vi har registreret',
  warehouseManagement: 'Lagerstyring',
  trade: 'Handel',
  notYetImplemented: 'Ikke implementeret endnu',
  notYetImplementedText: 'Denne funktion er ikke implementeret endnu. Vi arbejder på det! Du kan opnå lignende funktionalitet fra produktlisten',
  goBack: 'Gå tilbage',
  categories: 'Kategorier',
  category: 'Kategori',
  newCategory: 'Ny kategori',
  editCategory: 'Rediger kategori',
  deleteCategory: 'Slet kategori',
  categoryCreated: 'Kategori oprettet',
  categoryUpdated: 'Kategori opdateret',
  categoryDeleted: 'Kategori slettet',
  errorCreateCategory: 'Der opstod en fejl ved oprettelse af kategori, kontroller venligst alle felter igen.',
  errorUpdateCategory: 'Der opstod en fejl ved opdatering af kategori, kontroller venligst alle felter igen.',
  errorDeleteCategory: 'Der opstod en fejl ved sletning af kategori.',
  mandatoryCategoryName: '*Kategorinavn',
  categoryName: 'Kategorinavn',
  categoryDescription: 'Kategoribeskrivelse',
  categoriesPerPageText: 'Kategorier pr. side:',
  usePrintServer: "Brug Print Server (Silent Printing)",
  printJobSent: "Udskriftsjob sendt til server.",
  printJobsSent: "Alle udskriftsjob sendt til server.",
  printJobFailed: "Udskriftsjob mislykkedes",
  printServerConnectionError: "Kunne ikke oprette forbindelse til printserveren. Kører den?",
  printBatchFailed: "Udskriftsbatch mislykkedes. Mindst ét job kunne ikke sendes.",
  noLabelSelectedError: "Ingen etiketdesign valgt.",
  onlyInStock: "Kun produkter på lager",
  valueFromCostPrice: "Værdi baseret på kostpris",
  columns: 'Kolonner',
  resetColumns: 'Nulstil',
  showAll: 'Vis alle',
  sku: 'SKU',
  vat: 'Moms',
  supplierSku: 'Leverandør SKU',
  customField1: 'Brugerfelt 1',
  customField2: 'Brugerfelt 2',
  customField3: 'Brugerfelt 3',
  countryOfOrigin: 'Oprindelsesland',
  tariffCode: 'Tarifkode',
  newPassword: 'Nyt kodeord',
  leaveBlankKeepPassword: 'Efterlad tomt for at beholde nuværende',
  realQuantity: 'Sande antal (sætter lager til det angivne antal)',
  deleteSelected: 'Slet de valgte',
  deleteSelectedWarning: 'Slet de {count} valgte? Kan ikke fortrydes.',
  itemsDeleted: '{count} slettet',
  someDeletesFailed: '{failed} kunne ikke slettes',
  numberDecimals: 'Decimaler',
  showThousandsSeparator: 'Vis tusindtalsseparator',
  localizeExports: 'Eksporter med lokaliserede numre',
  adjustments: 'Reguleringer',
  dateFrom: 'Fra den',
  dateTo: 'Til den',
  allTypes: 'Alle',
  adjustmentAdd: 'Tilgang',
  adjustmentRemove: 'Afgang',
  adjustmentRegulate: 'Regulering',
  newAdjustment: 'Ny regulering',
  clearFilters: 'Nulstil',
  changeAmount: 'Ændring',
  dateTime: 'Tidspunkt',
  csvExported: 'CSV fil er dannet',
  xlsxExported: 'Excel fil er dannet',
  movements: 'Flytninger',
  newMovement: 'Ny flytning',
  fromLocation: 'Fra lokation',
  toLocation: 'Til lokation',
  available: 'Tilgængelige',
  noStockAnywhere: 'Ingen på lager',
  movementCreated: 'Flytning oprettet',
  movementFailed: 'Flytning fejlede',

  // Product-edit permission (users page)
  canEditProducts: 'Må redigere produkter',
  setProductEditPermission: 'Sæt produktredigering',
  inheritFromCompany: 'Arv fra firma',
  allowed: 'Tilladt',
  blocked: 'Spærret',
  selectedUsersCount: 'Valgte brugere ({count})',
  allUsersCount: 'Alle brugere ({count})',
  permissionSaved: 'Tilladelse gemt',
  permissionSaveFailed: 'Kunne ikke gemme tilladelsen',
  permissionsSavedCount: '{count} tilladelser gemt',
  somePermissionsFailed: '{failed} kunne ikke gemmes',
  companyDefaultScope: 'Firma-standard (alle med "Arv fra firma")',
  currentCompanyDefault: 'Nuværende firma-standard: {value}',
  selectLabelDesign: 'Vælg design',
  matchColumns: 'Match kolonner',
  exportProductsText: 'Eksportér alle produkter til en xlsx-fil, der kan re-importeres direkte.',
  exportComplete: '{count} produkter eksporteret',
  exportFailed: 'Eksport fejlede',
  noProductsToExport: 'Ingen produkter at eksportere',
  stockTotalReadOnly: 'Lager i alt (importeres ikke)',
  unitId: 'Enheds-ID',
  supplierId: 'Leverandør-ID',
  logout: 'Log ud'
};